import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';

const DashboardApiService = {
  getDashboard(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/dashboard`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  getLateRents(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/late-rents`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default DashboardApiService;



// WEBPACK FOOTER //
// ./src/services/api/DashboardApiService.js